import { Component, OnInit } from '@angular/core';
import { UserProfile } from 'src/app/core/models/user';
import { SessionService } from './../../../core/services/auth/session.service';
import { ScreenAction } from 'src/app/core/models/user-management/screen-action';
import { ItemValueModel } from 'src/app/core/models/user-management/item-value-model';
import { PlanTypeAction } from 'src/app/core/models/user-management/plan-type-action';
import { ScreenActionModel } from 'src/app/core/models/user-management/screen-action-model';
import { UserManagementService } from 'src/app/core/services/user-management/user-management.service';

@Component({
  selector: 'app-manage-plan-type',
  templateUrl: './manage-plan-type.component.html',
  styleUrls: ['./manage-plan-type.component.scss']
})
export class ManagePlanTypeComponent implements OnInit {

  myInnerHeight: any;
  isLoading = false;
  isLoginUser: UserProfile;
  screenActionList: Array<ScreenAction>;
  screenActionData: ScreenActionModel;
  planTypeList: Array<ItemValueModel>;
  isLoader = false;
  planTypeActionList: Array<PlanTypeAction>;

  constructor(private sessionService: SessionService, private userService: UserManagementService) {
    this.isLoginUser = new UserProfile();
    this.screenActionList = [];
    this.screenActionData = new ScreenActionModel();
    this.planTypeList = [];
    this.planTypeActionList = [];
    this.myInnerHeight = window.innerHeight - 150;
  }

  ngOnInit(): void {
    this.fetchUserProfile();
    this.fetchScreenActionData();
    this.fetchPlanTypeAction();
  }

  fetchUserProfile(): void {
    this.sessionService.getLoginUserInfo().subscribe((data: UserProfile) => {
      this.isLoginUser = data;
    });
  }

  fetchScreenActionData(): void {
    this.isLoading = true;
    this.userService.getScreenActionData().subscribe((data: ScreenActionModel) => {
      this.isLoading = false;
      this.screenActionList = data.screenActionList;
      this.planTypeList = data.planTypeList;
    });
  }

  fetchPlanTypeAction(): void {
    this.userService.getPlanTypeAction().subscribe((data: Array<PlanTypeAction>) => {
      this.planTypeActionList = data;
    });
  }

  checkScreenAction(actionId: number, planId: number): boolean {
    if (this.planTypeActionList) {
      const index = this.planTypeActionList.findIndex(x => x.actionId === actionId && x.planType === planId && x.isActive);
      return index >= 0 ? true : false;
    }
    return false;
  }

  updateRoleScreen(actionId: number, planId: number, status: boolean): void {
    const obj = new PlanTypeAction();
    obj.actionId = actionId;
    obj.planType = planId;
    obj.isActive = status;
    this.userService.updateScreenAction(obj).subscribe(() => {
      this.fetchPlanTypeAction();
    });
  }
}
